import { Box, keyframes } from '@mui/material';
import WreathSpinner from './WreathSpinner';

interface LoadingSpinnerProps {
	size?: number;
	variant?: 'default' | 'wreath';
}

// Exact length of the traced path, so both halves of the animation land on the top-left tip
const TRACE_LENGTH = 348.72;

// First half draws the "P" from inside the bowl to the top-left tip; second half erases it in the same direction
const drawLogo = keyframes`
	0% { stroke-dashoffset: ${TRACE_LENGTH}; animation-timing-function: cubic-bezier(0.3, 0, 0.45, 1); }
	50% { stroke-dashoffset: 0; animation-timing-function: cubic-bezier(0.37, 0, 0.55, 1); }
	100% { stroke-dashoffset: -${TRACE_LENGTH}; }
`;

const LoadingSpinner = ({ size = 100, variant = 'default' }: LoadingSpinnerProps) => {

	if (variant === 'wreath'){ return <WreathSpinner size={size} />; }

	return (
		<Box sx={{ width: '100%', height: '100%', m: 'auto', display: 'flex' }}>
			<Box
				component="svg"
				viewBox="0 0 136 162"
				xmlns="http://www.w3.org/2000/svg"
				role="img"
				aria-label="Loading"
				sx={{ m: 'auto', height: size, width: size }}
			>
				<g transform="matrix(1,0,0,1,-7711,-672)">
					<g transform="matrix(0.077626,0,0,0.310345,7115.611872,519.310345)">
						<g transform="matrix(75.79008,0,0,18.957133,11598.495896,753)">
							<g transform="matrix(1,0,0,1,-77.5,-14)">
								<g transform="matrix(1,0,0,1,-667.514374,-232.866005)">
									<g transform="matrix(0.929472,0,0,1.059398,529.17736,-24.233164)">
										<g transform="matrix(0.320542,0,0,0.28123,241.396079,255.899276)">
											<g transform="matrix(1,0,0,1,-201.5,-45)">
												<clipPath id="loading-spinner-clip">
													<rect x="0" y="0" width="403" height="90" />
												</clipPath>
												<g clipPath="url(#loading-spinner-clip)">
													<g transform="matrix(1,0,0,1,-99.6362,-55)">
														<g transform="matrix(1,0,0,1,53,487)">
															<g transform="matrix(1,0,0,1,-22.1794,-518.6042)">
																<g transform="matrix(1,0,0,1,95.6486,86.6042)">
																	<mask id="loading-spinner-mask" maskUnits="userSpaceOnUse" x="-50" y="-50" width="200" height="200">
																		<Box
																			component="path"
																			d="M 29.679,22.65 L 14.272,22.65 L 14.272,51.517 L 32.58,51.517 L 44.128,39.969 L 44.128,4.171 L -4.17,4.171 L -4.17,85.693 L -22.664,85.693 L -22.664,0"
																			fill="none"
																			stroke="white"
																			strokeWidth="8.34"
																			strokeLinecap="butt"
																			strokeLinejoin="miter"
																			strokeMiterlimit="3"
																			sx={{
																				strokeDasharray: TRACE_LENGTH,
																				strokeDashoffset: TRACE_LENGTH,
																				animation: `${drawLogo} 2.5s infinite`,
																				'@media (prefers-reduced-motion: reduce)': { animation: 'none', strokeDashoffset: 0 }
																			}}
																		/>
																	</mask>
																	<path
																		d="M0,89.863L-26.833,89.863L-26.833,0L-18.494,0L-18.494,81.523L-8.339,81.523L-8.339,0L48.298,0L48.298,41.696L34.307,55.688L10.102,55.688L10.102,18.479L29.679,18.479L29.679,26.82L18.441,26.82L18.441,47.346L30.853,47.346L39.958,38.242L39.958,8.341L0,8.341L0,89.863Z"
																		fill="rgb(113,198,172)"
																		fillRule="nonzero"
																		mask="url(#loading-spinner-mask)"
																	/>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</Box>
		</Box>
	);
};

export default LoadingSpinner;
